var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.666016C6.64002 0.666016 0.666687 6.63935 0.666687 13.9993C0.666687 21.3594 6.64002 27.3327 14 27.3327C21.36 27.3327 27.3334 21.3594 27.3334 13.9993C27.3334 6.63935 21.36 0.666016 14 0.666016ZM20.6667 15.3327H15.3334V20.666H12.6667V15.3327H7.33335V12.666H12.6667V7.33268H15.3334V12.666H20.6667V15.3327Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDark);
export default __webpack_public_path__ + "static/media/plus_dark.8312dac56f90e06bd95f3afb9b17e241.svg";
export { ForwardRef as ReactComponent };